import App from 'app/app.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/ContentStore.js';
import 'app/store/SubjectStore.js';

function JobCleanUpService(ShoppingCartStore, ContentStore, $uibModal, $window, SubjectStore, StatsdService) {
  this.cleanUpAndCanAddMoreJobs = function () {
    if ($window.maxJobCleanupEnabled && this.maxJobLimitReached()) {
      var subjectsInfo = R.map(function (subject) {
        return { id: subject.id, studentId: subject.studentId, masterSubjectId: subject.masterSubjectId };
      })(ShoppingCartStore.getSubjects());

      R.forEach(function (subject) {
        // Remove all empty jobs of verified students except active job from each student in student banner
        if (
          subject &&
          (subject.studentId || subject.masterSubjectId) &&
          !SubjectStore.isRecentJobInAnyVerifiedStudent(subject.id)
        ) {
          ShoppingCartStore.removeEmptySubjectById(subject.id);
        }
      })(subjectsInfo);

      StatsdService.incrementCounter('JOB_CLEAN_UP_WHEN_MAX_JOB_LOADED');
    }
    return this.canAddMoreJobs();
  };

  this.maxJobLimitReached = function () {
    return ShoppingCartStore.getNumberOfSubjects() >= ContentStore.getConfig().maxJobs;
  };

  this.canAddMoreJobs = function () {
    if (this.maxJobLimitReached()) {
      var modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        windowClass: '',
        template:
          '<lt-confirm message="CONFIRM_TOO_MANY_CHILDREN_MESSAGE" button-text="CONFIRM_TOO_MANY_CHILDREN_DISMISS_BUTTON_TEXT" ' +
          'bottom-message="CONFIRM_TOO_MANY_CHILDREN_BOTTOM_MESSAGE" close="modalCtrl.dismiss()"></lt-confirm>',
        controller: function () {
          this.dismiss = function () {
            modalInstance.close();
          };
        },
        controllerAs: 'modalCtrl'
      });
      return false;
    } else {
      return true;
    }
  };
}

App.service('JobCleanUpService', [
  'ShoppingCartStore',
  'ContentStore',
  '$uibModal',
  '$window',
  'SubjectStore',
  'StatsdService',
  JobCleanUpService
]);
